import * as React from 'react';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';

export default function ProductList() {
    return (
        <ImageList sx={{ width: '100%' }} cols={4}>
            {itemData.map((item) => (
                <ImageListItem key={item.img}>
                    <img
                        src={`${item.img}?w=248&h=164&fit=crop&auto=format`}
                        srcSet={`${item.img}?w=248&h=164&fit=crop&auto=format&dpr=2 2x`}
                        alt={item.title}
                        loading="lazy"
                    />
                    <ImageListItemBar title={item.title} position="below" />
                </ImageListItem>
            ))}
        </ImageList>
    );
}

const itemData = [
    {
        img: '/all-ro.jpeg',
        title: 'RO Products'
    },
    {
        img: '/ro-system.jpeg',
        title: 'Domestic RO Systems'
    },
    {
        img: '/home-ro.jpeg',
        title: 'Domestic RO Systems'
    },
    {
        img: '/ro-commercial.jpeg',
        title: 'Commercial RO Systems'
    }
];
